export class ExclusaoRegistroDto {
    public foreignSchemaTable: string;

    constructor(object?: any) {
        if (object) {
            this.foreignSchemaTable = object.foreignSchemaTable;
        }
    }
}
